import Vue from 'vue'
import '@/utils/filters'
import App from './App.vue'
import SlideVerify from 'vue-monoplasty-slide-verify';
import '@/assets/fonts/index.css'

Vue.use(SlideVerify)

// 路由引入
import router from '@/router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import swiper from 'swiper'
import 'swiper/swiper-bundle.css'

Vue.filter('stripHtml', function (value) {
    if (!value) return '';
    return value.replace(/<[^>]+>/g, '');
});
Vue.filter('formatTime', function (value) {
    if (!value) return '';
    return value.replace(/\s.*$/, "");
});
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
    router,

    beforeCreate() {
        Vue.prototype.$bus = this
    },
    render: h => h(App),
    swiper,
}).$mount('#app')
